import './styles';

import "core-js/fn/array/find"
import "core-js/fn/array/find-index"
import "core-js/fn/array/from"
import "core-js/fn/map"
import "core-js/fn/object/assign"
import "core-js/fn/promise"
import "core-js/fn/set"
import "isomorphic-fetch"
import "element-closest"
import "objectFitPolyfill"

// import objectFit from "object-fit";
import { Application } from "stimulus";
import { definitionsFromContext } from "stimulus/webpack-helpers";
import WindowHeight from  './components/window-height';
import WebglApp from './components/webgl/App';


const application = Application.start();
const context = require.context("./controllers", true, /\.js$/);
application.load(definitionsFromContext(context));

new WebglApp();

function run() {
    new WindowHeight();
    objectFitPolyfill();
}

window.addEventListener("load", run);


// WEBPACK FOOTER //
// ./mysite/resources/js/main.js